module.exports.ascii_letters = require('./ascii_letters')
module.exports.ascii_lowercase = require('./ascii_lowercase')
module.exports.ascii_uppercase = require('./ascii_uppercase')
module.exports.capwords = require('./capwords')
module.exports.punctuation = require('./punctuation')
